import { render, staticRenderFns } from "./SearchResulttypeProduct.vue?vue&type=template&id=36daeb8d"
import script from "./SearchResulttypeProduct.vue?vue&type=script&lang=js"
export * from "./SearchResulttypeProduct.vue?vue&type=script&lang=js"
import style0 from "./SearchResulttypeProduct.vue?vue&type=style&index=0&id=36daeb8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports